module.exports = __webpack_public_path__ + "img/emoji_esquerda.bea6638b.png";